import { Button, Card, Select, Space, Tabs } from 'antd';
import React, { useState } from 'react';

import { EdutainmentDetailModal } from '@/components/UI/EdutainmentDetailModal';
import type { EdutainmentDetailValues } from '@/components/UI/EdutainmentDetailModal/types';

import { TEST_EDUTAINMENT_DETAIL } from '../EditEdutainmentModal/constants';
import {
  HistoryTable,
  PendingReleaseTable,
  ReleasedTable,
  WaitingReviewTable,
} from './components';
import { PROGRAMS_OPTIONS } from './constants';
import styles from './index.module.scss';
import type { TableTabs } from './types';

export const ApplicationTables = () => {
  const [tab, setTab] = useState<TableTabs>('待審核');
  const [showDetailModal, setShowDetailModal] = useState(false);

  // TODO: 這邊的detailData之後應該會是從API那邊獲取，所以到時候就不需要這個state
  const [detailData, setDetailData] = useState<
    EdutainmentDetailValues | undefined
  >(undefined);

  const onTabChange = (tab: TableTabs) => {
    setTab(tab);
  };

  // TODO: 這個函數是到時候要給有查看按鈕的table用的
  const openDetailModal = () => {
    // TODO: 這邊的detailData是測試用的，邏輯待寫
    setDetailData({ ...TEST_EDUTAINMENT_DETAIL, refundPolicy: '' });
    setShowDetailModal(true);
  };

  const closeDetailModal = () => {
    setDetailData(undefined);
    setShowDetailModal(false);
  };

  return (
    <>
      <Space direction="vertical" size="middle" className={styles['w-full']}>
        <Space>
          <p>課程：</p>
          <Select
            allowClear
            options={PROGRAMS_OPTIONS}
            placeholder="請選擇課程名稱"
            className={styles.programSelector}
          />
        </Space>
        <Tabs
          onChange={onTabChange}
          items={[
            {
              label: '待審核',
              key: '待審核',
              children: (
                <Card>
                  <WaitingReviewTable />
                </Card>
              ),
            },
            {
              label: '待上架',
              key: '待上架',
              children: (
                <Card>
                  <PendingReleaseTable />
                </Card>
              ),
            },
            {
              label: '已上架',
              key: '已上架',
              children: (
                <Card>
                  <ReleasedTable />
                </Card>
              ),
            },
            {
              label: '歷史資料',
              key: '歷史資料',
              children: (
                <Card>
                  <HistoryTable />
                </Card>
              ),
            },
          ]}
        />
      </Space>

      {detailData ? (
        <EdutainmentDetailModal
          open={showDetailModal}
          onCancel={closeDetailModal}
          edutainment={detailData}
          modalFooter={[
            <Button key="ok" onClick={() => setDetailData(undefined)}>
              確認
            </Button>,
          ]}
        />
      ) : null}
    </>
  );
};
